import type { Education as EducationType } from '@seek/ca-myprofile-utils';
import { Qualifications } from '@seek/profile-read-ui';
import { useTranslations } from '@vocab/react';
import { Stack, Heading, Box, Divider } from 'braid-design-system';
import React from 'react';

import { EDUCATION } from 'src/components/Router';
import { useAppConfig } from 'src/modules/appConfig';

import { useShareableProfile } from '../data';

import translations from './.vocab';

export const Education = () => {
  const { zone } = useAppConfig();
  const { shareableProfile, shareableProfileCardEmpty } = useShareableProfile();
  const { t } = useTranslations(translations);
  const qualifications = shareableProfile?.qualifications || [];

  return shareableProfileCardEmpty[EDUCATION] ? null : (
    <>
      <Box id={EDUCATION} paddingY="xxlarge" data-automation={EDUCATION}>
        <Stack space="large">
          <Heading level="2" align="left">
            {t('Education')}
          </Heading>
          <Qualifications
            displayVariant="full-text-no-divider"
            showVerifiedText={true}
            qualifications={qualifications.map((qualification) => ({
              ...(qualification as EducationType),
              confirmed: true,
              showCertsyFunctionality: false,
              zone,
              replaceUrlTextWithLinks: false,
            }))}
          />
        </Stack>
      </Box>
      <Divider weight="regular" />
    </>
  );
};
